import React from 'react';
import { Box, Text } from '@mantine/core';

type CategorySectionProps = {
    title: string;
    children: React.ReactNode;
};

export function CategorySection({ title, children }: CategorySectionProps) {
    return (
        <Box className="rounded-lg border border-[#e6e9ef] bg-white p-3">
            <Text size="xs" fw={700} c="primary" mb={10}>
                {title}
            </Text>
            {children}
        </Box>
    );
}
